import React from "react";
import styles from './WelcomeMessage.module.sass';
import Loader from "../../../components/LoaderCircle";

const WelcomeMessage = ({isLoading}) => {

    return <div className={styles.container}>
                    <h1>Welcome!</h1>
                    <p>Select a friend to start chatting!</p>
                    { isLoading && <Loader/> }
                </div>
};

export default WelcomeMessage;